import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const useGetBankAccountNumberQuery = () => {
  const { mutateAsync, isLoading, isSuccess } = useMutation(async (accountId: string) =>
    api.get<string>(API_URL.ACCOUNTS_NUMBER_DECRYPTED_BY_ACCOUNT_ID(accountId), {
      responseType: 'text',
    })
  );
  return {
    getAccountNumber: mutateAsync,
    isLoading,
    isSuccess,
  };
};
